import React from 'react'
import LayoutSmartFormEngine from './layout/LayoutSmartFormEngine'

export const SmartFormEngineScreen = () => {
    return (
        <LayoutSmartFormEngine />
    )
}
